import React from 'react';
import { Check, Gift } from 'lucide-react';
import { Section } from './Shared';
export const MethodOverview = () => {
  const tomos = [{
    color: 'bg-purple-100/60 border-purple-200',
    icon: '🟣',
    title: 'TOMO I — El Volcado de Emergencia',
    subtitle: 'Escritura akáshica para vaciar tu mente en 7 minutos',
    outcome: 'Apagás el loop mental y recuperás la claridad.'
  }, {
    color: 'bg-blue-100/60 border-blue-200',
    icon: '🔵',
    title: 'TOMO II — Limpieza de Vínculos Agotadores',
    subtitle: 'Cortá los cordones energéticos con quienes te drenan',
    outcome: 'Terminás el día con energía propia.'
  }, {
    color: 'bg-emerald-100/60 border-emerald-200',
    icon: '🟢',
    title: 'TOMO III — El Detector de Mentiras Propias',
    subtitle: 'Desarmá las creencias que te frenan en automático',
    outcome: 'Decisiones desde vos misma, no desde el miedo heredado.'
  }, {
    color: 'bg-slate-100/60 border-slate-200',
    icon: '🌙',
    title: 'TOMO IV — Protocolo Apagar la Mente',
    subtitle: 'Secuencia nocturna para silenciar el ruido y dormir',
    outcome: 'Te levantás descansada y con el campo ordenado.'
  }, {
    color: 'bg-rose-100/60 border-rose-200',
    icon: '🍷',
    title: 'TOMO V — El Abrazo a Tu Sombra',
    subtitle: 'Reconciliate con las partes de vos que escondiste',
    outcome: 'Dejás de autosabotearte desde la compasión real.'
  }, {
    color: 'bg-green-100/60 border-green-200',
    icon: '🌲',
    title: 'TOMO VI — El Mapa del Próximo Paso Real',
    subtitle: 'De la parálisis a la acción desde un campo limpio',
    outcome: 'Sabés hacia dónde ir y te movés sin miedo.'
  }];
  const checklist = ['Protocolo akáshico paso a paso listo para aplicar', 'Ejercicios de escritura terapéutica guiados', 'Técnicas de visualización y limpieza energética', 'Preguntas de cierre para profundizar el proceso', 'Marco teórico akáshico y holístico explicado con claridad', 'Conexión entre cada tomo para un proceso secuencial real', '100% diseñado para aplicar sola, a tu ritmo'];
  return <Section id="method" data-id="element-176">
      <div className="text-center mb-16" data-id="element-177">
        <div className="inline-flex items-center space-x-2 bg-brand-surface border border-brand-gold/30 px-4 py-1.5 rounded-full mb-6" data-id="element-178">
          <span className="text-xl" data-id="element-179">🌟</span>
          <span className="font-serif font-semibold tracking-wider text-brand-gold text-sm md:text-base" data-id="element-180">
            MÉTODO BORRÓN Y CUENTA NUEVA
          </span>
        </div>
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4" data-id="element-181">
          6 Tomos + 2 Bonus — Sistema Completo de Sanación Akáshica
        </h2>
        <p className="text-brand-muted text-[18px]" data-id="element-182">
          180+ páginas de protocolos listos para aplicar. Todo resuelto.
        </p>
      </div>

      <h3 className="text-2xl font-serif font-bold text-center gold-gradient-text mb-[35px]" data-id="element-183">
        6 TOMOS COMPLETOS
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-184">
        {tomos.map((tomo, i) => <div key={i} className={`${`${`rounded-2xl p-6 md:p-8 border ${tomo.color} backdrop-blur-sm`} pt-[20px] pb-[20px] pl-[20px] pr-[20px]`} pt-[15px] pb-[15px] pl-[15px] pr-[15px]`} data-id="element-185">
            <div className="text-3xl mb-3" data-id="element-186">{tomo.icon}</div>
            <h4 className="font-serif font-bold mb-2 text-[15px]" data-id="element-187">
              {tomo.title}
            </h4>
            <p className="text-brand-gold/90 font-medium mb-4 text-[14px]" data-id="element-188">
              {tomo.subtitle}
            </p>
            <p className="text-brand-text/70 text-[12px]" data-id="element-189">
              <span className="font-bold text-brand-gold" data-id="element-190">→</span>{' '}
              {tomo.outcome}
            </p>
          </div>)}
      </div>

      <div className="glass-panel rounded-3xl p-8 md:p-12 max-w-3xl mx-auto pt-[30px] pb-[30px] pl-[30px] pr-[30px] mb-[90px]" data-id="element-191">
        <h4 className="text-xl font-serif font-bold mb-6 text-center" data-id="element-192">
          Cada tomo incluye:
        </h4>
        <ul className="space-y-4" data-id="element-193">
          {checklist.map((item, i) => <li key={i} className="flex items-start" data-id="element-194">
              <Check className="w-5 h-5 text-brand-gold mr-3 mt-0.5 shrink-0" data-id="element-195" />
              <span className="text-brand-text/90 text-[14px]" data-id="element-196">{item}</span>
            </li>)}
        </ul>
      </div>

      <div className="text-center mb-12" data-id="element-197">
        <h3 className="md:text-4xl font-serif font-bold mb-4 text-[24px]" data-id="element-198">
          🎁 2 BONUS ESTRATÉGICOS
        </h3>
        <p className="text-brand-muted text-lg" data-id="element-199">
          Siempre incluidos. Siempre gratis.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-200">
        <div className="glass-panel rounded-2xl p-6 border-brand-gold/30 relative overflow-hidden pt-[20px] pb-[20px] pl-[20px] pr-[20px]" data-id="element-201">
          <div className="absolute top-0 right-0 bg-brand-gold text-brand-dark text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-202">
            GRATIS
          </div>
          <Gift className="w-8 h-8 text-brand-gold mb-3" data-id="element-203" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-204">
            BONUS 1 — 40 Disparadores Akáshicos
          </h4>
          <p className="text-brand-gold/90 text-sm font-medium mb-3" data-id="element-205">
            40 preguntas organizadas por emoción para cuando no sabés qué
            escribir
          </p>
          <div className="text-sm" data-id="element-206">
            <span className="line-through text-brand-text/50 mr-2" data-id="element-207">
              Valor: $5.000
            </span>{' '}
            <span className="text-brand-gold font-bold" data-id="element-208">
              → GRATIS con tu pack
            </span>
          </div>
        </div>

        <div className="glass-panel rounded-2xl p-6 border-brand-gold/30 relative overflow-hidden" data-id="element-209">
          <div className="absolute top-0 right-0 bg-brand-gold text-brand-dark text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-210">
            GRATIS
          </div>
          <Gift className="w-8 h-8 text-brand-gold mb-3" data-id="element-211" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-212">
            BONUS 2 — Protocolo de Blindaje Energético
          </h4>
          <p className="text-brand-gold/90 text-sm font-medium mb-3" data-id="element-213">
            Herramientas para proteger tu energía en entornos y personas que te
            drenan
          </p>
          <div className="text-sm" data-id="element-214">
            <span className="line-through text-brand-text/50 mr-2" data-id="element-215">
              Valor: $5.000
            </span>{' '}
            <span className="text-brand-gold font-bold" data-id="element-216">
              → GRATIS con tu pack
            </span>
          </div>
        </div>
      </div>

      <div className="text-center mt-8" data-id="element-217">
        <p className="font-medium bg-brand-surfaceLight/50 inline-block px-6 py-3 rounded-full border border-brand-gold/20 text-[12px]" data-id="element-218">
          Valor total de los Bonus:{' '}
          <span className="line-through text-brand-text/50 mx-1 text-[12px]" data-id="element-219">
            $10.000
          </span>{' '}
          <span className="text-brand-gold font-bold" data-id="element-220">
            → GRATIS con tu Método
          </span>
        </p>
      </div>
    </Section>;
};